import { useRef, useState, useEffect } from 'react';

export const useParallax = (transformAmount: number, delay: number = 0) => {
    const [transformX, setTransformX] = useState(0);
    const [transformY, setTransformY] = useState(0);
    const [isParallaxActive, setIsParallaxActive] = useState(false);
    const panelRef = useRef<HTMLDivElement>(null);
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        if (panelRef.current) {
            const panelElement = panelRef.current;

            const handleMouseMove = (mouseEvent: MouseEvent) => {
                // Параллакс работает только если активирован
                if (!isParallaxActive) {
                    return;
                }

                const { clientX: mouseX, clientY: mouseY } = mouseEvent;
                const { left: centerX, top: centerY, width, height } = panelElement.getBoundingClientRect();

                const percentX = (mouseX - (centerX + width / 2)) / (width / 2);
                const percentY = -((mouseY - (centerY + height / 2)) / (height / 2));

                setTransformX(percentX * transformAmount);
                setTransformY(percentY * transformAmount);
            };

            const handleMouseEnter = () => {
                // Запускаем параллакс с задержкой
                timeoutRef.current = setTimeout(() => {
                    setIsParallaxActive(true);
                }, delay);
            };

            const handleMouseLeave = () => {
                // Отменяем таймер если мышь ушла до активации параллакса
                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                    timeoutRef.current = null;
                }

                setIsParallaxActive(false);
                setTransformX(0);
                setTransformY(0);
            };

            panelElement.addEventListener('mousemove', handleMouseMove);
            panelElement.addEventListener('mouseenter', handleMouseEnter);
            panelElement.addEventListener('mouseleave', handleMouseLeave);

            return () => {
                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                }
                panelElement.removeEventListener('mousemove', handleMouseMove);
                panelElement.removeEventListener('mouseenter', handleMouseEnter);
                panelElement.removeEventListener('mouseleave', handleMouseLeave);
            };
        }
    }, [transformAmount, delay, isParallaxActive]);

    return {
        panelRef,
        transformX,
        transformY,
    };
};
